import React, { useEffect, useState, useContext } from "react"
import { graphql } from "gatsby"
import Layout from "../components/wrappers/layout"
import SEO from "../components/seo"
import CardArticle from "../components/card-article"
import SiteHeaderAlt from "../components/wrappers/site-header-alt"
import { GlobalDispatchContext } from "../context/GlobalContextProvider"
import { domain, formatRichText, stripString } from "../utils"
import Markdown from "markdown-to-jsx"
import { FormattedMessage } from "react-intl";
import Media from "../components/media";
import Link from "../components/link";
import { getSinglePage } from "../utils";
import classNames from "classnames"

const BlogDetail = ({ data }) => {
  const { blog, headers, footers } = data.strapi
  const {
    language,
    title,
    headerImage,
    author,
    authorHeading,
    category,
    categoryLink,
    date,
    dateLabel,
    intro,
    main,
    articles,
  } = blog
  const header = headers && headers.find((header)=>  header.language === language ); 
  const footer = footers && footers.find((footer)=>  footer.language === language ) || {}; 

  const seoTitle = blog && blog.seo && blog.seo.metaData?.metaTitle || title  || "Blog detail ";
  const seoDescription = blog &&  blog.seo && blog.seo.metaData?.metaDescription || title||"blog detail";
  
  const allPages = data?.allSitePage?.nodes; 
  const webpages = blog && blog.webpages && blog.webpages || {}; 
  const redirectTo = getSinglePage(webpages, allPages); 
  const [anchorLinks, setAnchorLinks] = useState([])
  const newAnchorLinks = []; 

   useEffect(() => {
    main && main.forEach((component) => {
      if (component.__typename === "STRAPI_ComponentPlainRichTextBlock" || component.__typename === "STRAPI_ComponentPlainPaddedRichText") {
        component &&  component.anchorText && newAnchorLinks.push({header: component.anchorText , display: true}); 
      } 
    })

    setAnchorLinks(newAnchorLinks);

  }, []); 
  console.log(main, "newAnchorLinks"); 
  return (
    <Layout header={header} footer={footer} language={language} redirectTo={redirectTo} anchorLinks={anchorLinks}>
      <SEO template="blog-detail" title={seoTitle} description={seoDescription} redirectTo={redirectTo} />
      <SiteHeaderAlt header={header} anchorLinks={anchorLinks}>
        <article className="blog section">
          
          <header className="header container">
            <div className="row">
              <div className="offset-md-1 col-md-8">
                <h1 className="header__heading header__heading--space">
                  {title}
                </h1>
              </div>
            </div>
          </header>

          <div className="blog-detail__hero">
            <img
              className="image--fluid"
              src={`${headerImage && headerImage.url}`}
              alt="alt"
            />
          </div>
          <div className="blog-detail__content">
            <div className={[
              "container",
              "blog-detail__header",
              intro ? "" : "blog-detail__header--nointro"
            ].join(" ")}>
              <div className="row">
                <div className="col-md-3 offset-md-1">
                  <div className={`blog-detail__meta d-flex  ${categoryLink ? "" : "blog-detail__meta--authorwithdate"}`}>
                    <author className="blog-detail__author">
                      <div className="blog-detail__author-avatar">
                        <img
                          className="image--fluid"
                          src={`${author && author.picture && author.picture.url}`}
                          alt={author && author.name}
                          loading="lazy"
                        />
                      </div>
                    </author>
                    <div className="blog-detail__info">
                      <ul className={`blog-detail__directory blog-detail__directory--author directory`}>
                        <li>
                          <dt className="directory__title"><FormattedMessage id="basic.author" defaultMessage="Autor"/></dt>
                          <dd className="directory__value">{author && author.name}</dd>
                        </li>
                        {categoryLink && (
                          <li className="d-none d-md-block">
                            <dt className="directory__title"><FormattedMessage id="basic.category" defaultMessage="Category"/></dt>
                            <dd className="directory__value">
                              <Link to={`/${language}/${categoryLink && categoryLink.path}`}>
                                {categoryLink && categoryLink.label}
                              </Link>
                            </dd>
                          </li>
                        )}
                        <li className={categoryLink ? "d-none d-md-block" : ""}>
                          <dt className="directory__title"><FormattedMessage id="basic.date" defaultMessage="Datum"/></dt>
                          <dd className="directory__value">
                            {date && date
                              .split("-")
                              .reverse()
                              .join(".")}
                          </dd>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {categoryLink && (
                    <ul className="blog-detail__directory blog-detail__directory--details directory d-md-none">
                      <li>
                        <dt className="directory__title"><FormattedMessage id="basic.category" defaultMessage="Category"/></dt>
                        <dd className="directory__value">
                          <Link to={`/${language}/${categoryLink && categoryLink.path}`}>
                            {categoryLink && categoryLink.label}
                          </Link>
                        </dd>
                      </li>
                      <li>
                        <dt className="directory__title"><FormattedMessage id="basic.date" defaultMessage="Datum"/></dt>
                        <dd className="directory__value">
                          {date && date
                            .split("-")
                            .reverse()
                            .join(".")}
                        </dd>
                      </li>
                    </ul>
                  )}
                </div>
                <div className="col-md-7">
                  <div className="blog-detail__lead">{intro}</div>
                </div>
              </div>
            </div>
            {main.map((content, index) => {
              if (content.__typename === "STRAPI_ComponentPlainRichTextBlock") {
                return (
                  <div  className={classNames("blog-detail__body", {"anchor-text": stripString(content.anchorText && content.anchorText ||'') })} id={stripString(content.anchorText && content.anchorText ||'')}>
                    <div className="container">
                      <div className="row">
                        <div key={index} className="col-md-6 offset-md-5 rich-text">
                          <Markdown options={{overrides: {a: {component: Link}}}}>{formatRichText(content.richText)}</Markdown>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              } else if (content.__typename === "STRAPI_ComponentPlainPaddedRichText") {
                return (
                  <div  className={classNames("blog-detail__body blog-detail__body--padded", {"anchor-text": stripString(content.anchorText && content.anchorText ||'') })} id={stripString(content.anchorText && content.anchorText ||'')}>
                    <div className="container">
                      <div className="row">
                        <div key={index} className="col-md-6 offset-md-5 rich-text">
                          <Markdown options={{overrides: {a: {component: Link}}}}>{formatRichText(content.richText)}</Markdown>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              } else if (content.__typename === "STRAPI_ComponentPlainMedia") {

                return (
                  <div className="blog-detail__image">
                    <Media media={content.media} width={'semiMedium' ||content.width} withCaption={true} />
                  </div>
                )
              }
            })}
          </div>
        </article>

        <section className="section blog-related cards-articles">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <header className="blog-related__header header">
                  <h1 className="header__heading header__heading--space">
                    {/* <small className="header__preheading">{articles && articles.sup}</small> */}
                    {articles && articles.heading}
                  </h1>
                </header>
              </div>
            </div>
            <div className="row card-articles">
              {articles && articles.relatedCard.map((relatedCard) => {
                const article = relatedCard.blog || relatedCard.case_study;

                return <CardArticle article={article} path={relatedCard.blog ? 'blog' : 'case-studies'} />
              })}
            </div>
          </div>
        </section>
      </SiteHeaderAlt>
    </Layout>
  )
}

export default BlogDetail

export const pageQuery = graphql`
  query BlogDetail($id: ID!, $language: String!) {
    allSitePage {
      nodes {
        path
      }
    }
    strapi {
      blog(id: $id) {
          webpages {
            about_us {
              language
            }
            contact {
              language
            }
            case_study {
              slug
              language
            }
            blogs_overview {
              language
            }
            cases_overview {
              language
            }
            careers_overview {
              language
            }	
            services_overview {
              language
            }
            blog {
              language
              slug
            }
            career {
              language
              slug
            }
            homepage {
              slug
              language
            }
            service_design {
              slug
              language
            }
            service_technical {
              slug
              language
            }
            service_casey_new {
              slug
              language
            }
            service_casey {
              slug
              language
            }
            plainpage {
              language
              slug
            }
         }
        seo {
          metaData {
            metaDescription
            metaTitle
          }
        }
        language
        title
        headerImage {
          url
        }
        authorHeading
        author {
          name
          picture {
            url
          }
        }
        category
        categoryLink {
          label
          path
        }
        date
        dateLabel
        intro
        main {
          ... on STRAPI_ComponentPlainRichTextBlock {
            __typename
            richText
            anchorText
          }
          ... on STRAPI_ComponentPlainPaddedRichText {
            __typename
            richText
            anchorText
          }
          ... on STRAPI_ComponentPlainMedia {
            __typename
            media {
              url
              ext
              alternativeText
              caption
              mime
            }
            width
          }
        }
        articles {
          sup
          heading
          relatedCard {
            blog {
              ...CardArticleBlog
            }
            case_study {
              ...CardArticleCaseStudy
            }
          }
        }
      }
      headers(where: {language: $language}) {
        ...SiteHeader
      }
      footers(where: { language: $language }) {
        ...SiteFooter
      }
    }
  }
`
